var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxFind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1 31.614a12.58 12.58 0 0111.473 7.408 12.565 12.565 0 01-2.052 13.497l12.302 13.957L73.116 68 60.844 54.104a12.58 12.58 0 01-19.642-5.809 12.566 12.566 0 016.137-15.272 12.582 12.582 0 015.761-1.394v-.015zm0 22.856c2.73 0 5.346-1.084 7.276-3.013A10.282 10.282 0 0053.1 33.9a10.292 10.292 0 00-7.276 3.012A10.283 10.283 0 0053.1 54.47z",
    fill: "#2E5ECC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.199 66.257l17.153-6.758m-17.153 6.758V30.39m0 35.866L4.57 53.949V18.956M34.2 30.391L4.57 18.955M34.2 30.391l29.108-11.955m-58.737.52L34.2 7l29.108 11.436m0 0v15.593",
    stroke: "#2E5ECC",
    strokeWidth: 4
  })));
}

export default SvgBoxFind;